import { render } from "./providerDueDiligence.vue?vue&type=template&id=ea166bf8&scoped=true&ts=true"
import script from "./providerDueDiligence.vue?vue&type=script&lang=ts"
export * from "./providerDueDiligence.vue?vue&type=script&lang=ts"

import "./providerDueDiligence.vue?vue&type=style&index=0&id=ea166bf8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea166bf8"]])

export default __exports__